var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2819 17.4711C9.44325 17.4711 6.33205 14.36 6.33205 10.5213C6.33205 6.68273 9.44325 3.57153 13.2819 3.57153C17.1205 3.57153 20.2317 6.68273 20.2317 10.5213C20.2317 14.36 17.1205 17.4711 13.2819 17.4711ZM18.9888 38.1109C17.6058 36.6561 16.7568 34.6893 16.7568 32.5291C16.7568 28.6406 19.5089 25.3858 23.1668 24.6028C21.7884 20.4607 17.8873 17.4711 13.2819 17.4711C7.52394 17.4711 2.85715 22.1379 2.85715 27.8959V46.4287H15.5985V45.2704C15.5985 42.3897 16.9201 39.8113 18.9888 38.1109ZM36.4479 17.4711C31.8425 17.4711 27.9425 20.4607 26.5629 24.6028C30.2209 25.3858 32.973 28.6406 32.973 32.5291C32.973 34.6893 32.1239 36.6561 30.7409 38.1109C32.8097 39.8113 34.1313 42.3897 34.1313 45.2704V46.4287H46.8726V27.8959C46.8726 22.1379 42.2058 17.4711 36.4479 17.4711ZM43.3977 10.5213C43.3977 6.68273 40.2865 3.57153 36.4479 3.57153C32.6093 3.57153 29.4981 6.68273 29.4981 10.5213C29.4981 14.36 32.6093 17.4711 36.4479 17.4711C40.2865 17.4711 43.3977 14.36 43.3977 10.5213ZM24.8649 38.3206C21.0263 38.3206 17.9151 41.4318 17.9151 45.2704V46.4287H31.8147V45.2704C31.8147 41.4318 28.7035 38.3206 24.8649 38.3206ZM30.6564 32.5291C30.6564 29.331 28.0629 26.7376 24.8649 26.7376C21.6668 26.7376 19.0734 29.331 19.0734 32.5291C19.0734 35.7271 21.6668 38.3206 24.8649 38.3206C28.0629 38.3206 30.6564 35.7271 30.6564 32.5291Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.6e37f8c2a2300353641a67f534887d57.svg";
export { ForwardRef as ReactComponent };